import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";
import { AdminProductsService } from "../../../pages/admin-pages/products/services/admin-products.service";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { FailState } from "../../models/fail-state";
import { MonitoringRegimeDefaultsState } from "../../models/mp-admin/monitoring-regime-defaults-state";
import { AppState } from "../../reducers";
import { AdminProductsSelectors } from "../../selectors/admin-products.selectors";

@Injectable()
export class MonitoringRegimeDefaultsEffects {
	monitoringRegimeDefaults = createEffect(() =>
		this.actions.pipe(
			ofType(AdminProductsActions.monitoringRegimeDefaults.get),
			withLatestFrom(this.store.select(AdminProductsSelectors.monitoringRegimeDefaults)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(AdminProductsActions.monitoringRegimeDefaults.getSuccess({ state }))
					: of(AdminProductsActions.monitoringRegimeDefaults.getApi())
			)
		)
	);

	monitoringRegimeDefaultsApi = createEffect(() =>
		this.actions.pipe(
			ofType(AdminProductsActions.monitoringRegimeDefaults.getApi),
			switchMap(() =>
				this.service.getMonitoringRegimeDefaults().pipe(
					map((regimeDefaults) =>
						AdminProductsActions.monitoringRegimeDefaults.getSuccess({
							state: { regimeDefaults, loading: false, hasLoaded: true }
						})
					),
					catchError((error) =>
						of(AdminProductsActions.monitoringRegimeDefaults.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private service: AdminProductsService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: MonitoringRegimeDefaultsState): boolean {
		return (
			state !== undefined &&
			!_.has(state, "error") &&
			!state.loading &&
			state.hasLoaded === true &&
			_.has(state, "regimeDefaults") &&
			state.regimeDefaults !== undefined
		);
	}
}
